import React from 'react';
import { Tag } from 'syngenta-digital-cropwise-react-ui-kit';
import { isSelectKey } from '../../../TagManager/helpers/keyboardUtils';

export interface EquipmentTagProps {
  label: React.ReactNode;
  onClose: () => void;
}

const EquipmentTag = ({
  label,
  onClose
}: EquipmentTagProps): React.ReactElement => {
  const onPreventMouseDown = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (isSelectKey(e.key)) {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <Tag
      onClose={onClose}
      onKeyDown={handleKeyDown}
      onMouseDown={onPreventMouseDown}
      closable
      style={{ textTransform: 'none' }}
    >
      {label}
    </Tag>
  );
};

export default EquipmentTag;
